<template>
  <tk-container class="drain" :status="status">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      排水时间
      <span slot="right-menu" @click="setConfig">设置</span>
    </tkui-header>
    <div class="body">
      <div class="item">
        <p class="itemName">选择星期</p>
        <tk-flex wrap>
          <tk-flex middle class="tk-grid-4" v-for="(item, index) in date" :key="index">
            <div class="dateBtn" :class="{'selected': dateSelected.includes(item)}" @click="select(item)">{{item}}</div>
          </tk-flex>
        </tk-flex>
      </div>
      <p class="name">设置排水时间</p>
      <div class="item">
        <tk-flex middle between>
          <p class="text">排水时间</p>
          <div class="picker">
            <tkui-list style="position: absolute;width: 100%;height: 20px;opacity: 0;left: 0;top: 0;">
              <tkui-list-picker v-model="time" :items="timeList" label=""></tkui-list-picker>
            </tkui-list>
            <p class="text" v-if="time.length === 3 && time[0] !== '' && time[2] !== ''">{{time.join('')}}</p>
            <tk-icon v-else style="color:#999999;height: 16px;">return_copy</tk-icon>
          </div>
        </tk-flex>
      </div>
    </div>
  </tk-container>
</template>

<script>
  import time from '../../../assets/js/time'
  var timeList = [
    time.hour, [':'], time.minute
  ]
  export default {
    data () {
      return {
        time: [],
        date: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
        dateSelected: [],
        timeList: timeList,
        status: false,
        machineStatus: {}
      }
    },
    computed: {
      machine () {
        return this.$store.state.machine
      },
      user () {
        return this.$store.state.user.objectId
      }
    },
    created () {
      this.initStatus()
    },
    methods: {
      async initStatus () {
        try {
          this.status = 'loading'
          let status = await this.$tkParse.getList('/classes/status', {
            'params': {
              'where': {
                'machine': this.machine.objectId
              }
            }
          })
          if (status[0]) {
            this.machineStatus = status[0]
            this.dateSelected = [...status[0].drainWorkday]
            this.time = [status[0].drainWaterHour.toString().padStart(2, '0'), ':', status[0].drainWaterMinute.toString().padStart(2, '0')]
          }
          this.status = false
        } catch (e) {
          this.status = 'error'
          this.$tkGlobal.toast.add('获取设备状态失败')
        }
      },
      back () {
        this.$back()
      },
      async setConfig () {
        try {
          let res = await this.$tkParse.getData(`/classes/machine/${this.machine.objectId}`)
          if (!res.online) {
            if (this.machineStatus.drainWorkday) {
              this.dateSelected = [...this.machineStatus.drainWorkday]
            }
            if (this.machineStatus.drainWaterHour && this.machineStatus.drainWaterMinute) {
              this.time = [this.machineStatus.drainWaterHour.toString().padStart(2, '0'), ':', this.machineStatus.drainWaterMinute.toString().padStart(2, '0')]
            }
            this.status = false
            this.$tkGlobal.toast.add('设备离线，无法设置')
            return
          }
          this.status = 'waiting'
          let status = {}
          status.drainWorkday = this.dateSelected
          if (this.time.length === 3) {
            status.drainWaterHour = Number(this.time[0])
            status.drainWaterMinute = Number(this.time[2])
          }
          await this.$cloudAjax.post('/index/setConfig', {
            'machine': this.machine.objectId,
            'status': status,
            'type': '排水时间',
            'user': this.user,
            'deviceId': this.machine.deviceId
          })
          this.status = false
          this.$tkGlobal.toast.add('设置成功')
        } catch (e) {
          if (this.machineStatus.drainWorkday) {
            this.dateSelected = [...this.machineStatus.drainWorkday]
          }
          if (this.machineStatus.drainWaterHour && this.machineStatus.drainWaterMinute) {
            this.time = [this.machineStatus.drainWaterHour.toString().padStart(2, '0'), ':', this.machineStatus.drainWaterMinute.toString().padStart(2, '0')]
          }
          this.status = false
          this.$tkGlobal.toast.add('设置失败')
        }
      },
      select (item) {
        let index = this.dateSelected.indexOf(item)
        if (index !== -1) {
          this.dateSelected.splice(index, 1)
        } else {
          this.dateSelected.push(item)
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .body{
    p {
      margin-bottom: 0;
    }
    .item{
      padding: 15px;
      background: #ffffff;
      .picker{
        position:relative;
        width: 50px;
        height: 20px;
        text-align: right;
      }
      .text{
        color: #333333;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 0!important;
      }
      .itemName{
        font-size: 14px;
        color: #999999;
        margin-bottom: 10px;
      }
      .dateBtn{
        width: 90px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: #666666;
        background: #EBF5FD;
        margin-bottom: 15px;
        border-radius: 4px;
        font-size: 16px;
      }
      .selected{
        background: #0091FF;
        color: #ffffff;
      }
      .option{
        height: 45px;
        border-bottom: 1px solid #F1F5F8;
        .key{
          color: #666666;
          font-size: 14px;
        }
        .val{
          color: #333333;
          font-size: 16px;
          font-weight: 700;
        }
      }
      .itemName2{
        color: #333333;
        font-size: 16px;
        font-weight: 700;
      }
      .val2{
        font-size: 14px;
        color: #666666;
      }
      .drainTime{
        color: #333333;
        font-size: 16px;
        font-weight: 700;
      }
    }
    .name{
      font-size: 14px;
      color: #999999;
      padding-left: 15px;
      height: 35px;
      line-height: 35px;
      margin-bottom: 0!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/remote/drain.vue